import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-log-detail",
	templateUrl: "./log-detail.component.html",
	styleUrls: ["./log-detail.component.css", "../view-application-logs.component.css"],
})
export class LogDetailComponent implements OnInit {
	constructor(public ref: DynamicDialogRef, private dialogConfig: DynamicDialogConfig) {}

	ngOnInit(): void {
		this.rawData = this.dialogConfig.data.Data;

		this.logData.ApplicationName = this.rawData.ApplicationName;
		this.logData.MessageType = this.rawData.LogMessageTypeDesc;
		this.logData.DateAndTime = this.rawData.LogDT.toString();
		this.logData.ModuleName = this.rawData.LogModuleName;
		this.logData.Message = this.rawData.LogText;
		this.logData.LoggedBy = this.rawData.User_PersonName;
	}

	rawData: any;

	logData = {
		ApplicationName: "",
		MessageType: "",
		DateAndTime: "",
		ModuleName: "",
		Message: "",
		LoggedBy: "",
	};

	//////////////////////////////
	// Buttons
	//////////////////////////////

	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}

	//////////////////////////////
}
